import * as React from 'react';
import classes from '../Auth.module.scss';
import { RegisterOptions, UseFormReturn } from 'react-hook-form';
import {
  RegisterEmailAvailableQueryVariables,
  SocialOAuthContext,
  SocialOAuthProvider,
  StartSocialOAuthMutationFn
} from '../../../models/graphql';
import { BoxNotification } from '../../../components/containers/BoxNotification';
import { Button } from '../../../components/actions/Button';
import { ButtonColorsEnum } from '../../../constants/button-colors';
import { IconsEnum } from '../../../constants/icons';
import { Input } from '../../../components/forms/Input';
import { IInvitation } from '../../../models/auth';
import { InviteNotification } from '../InviteNotification';
import { InputTypes } from '../../../constants/form';
import { SubmitHandler } from 'react-hook-form/dist/types/form';

export type SignupStep1ViewProps = {
  //
  emailRules: RegisterOptions;
  formInstance: UseFormReturn<RegisterEmailAvailableQueryVariables>;
  invitation: IInvitation | null;
  onSubmit: SubmitHandler<RegisterEmailAvailableQueryVariables>;
  signupError: string | JSX.Element;
  startSocialOAuth: StartSocialOAuthMutationFn;
  submitted: boolean;
};

export const SignupStep1View = (props: SignupStep1ViewProps): JSX.Element => {
  const errorMessage =
    props.signupError && !props.submitted ? (
      <div className={'margin-bottom-small-32'}>
        <BoxNotification type={'error'}>{props.signupError}</BoxNotification>
      </div>
    ) : null;
  const invitationBanner = props.invitation ? (
    <div className={'margin-bottom-small-32'}>
      <InviteNotification organizationName={props.invitation.organizationName} />
    </div>
  ) : null;
  // we need to cast UseFormReturn<T> back to UseFormReturn
  const formInstance: UseFormReturn = props.formInstance as unknown as UseFormReturn;

  return (
    <div className={classes.Title}>
      <div className={'margin-bottom-small-40'}>
        <h2>Sign Up</h2>
      </div>
      {invitationBanner}
      {errorMessage}
      <div className={'margin-bottom-small-16'}>
        <Button
          className={classes.GoogleButton}
          action={async () => {
            try {
              await props.startSocialOAuth({
                variables: {
                  oAuthProvider: SocialOAuthProvider.GOOGLE,
                  context: SocialOAuthContext.SIGNUP
                }
              });
            } catch (e) {
              /* need to have catch due tu Promise runtime error */
            }
          }}
          color={ButtonColorsEnum.white}
          expanded
          disabled={props.submitted}
          icon={{ side: 'left', value: IconsEnum.google }}
          size={'large'}
          type={'button'}
          variant={'solid'}>
          Sign Up with Google
        </Button>
      </div>
      <div className={'margin-bottom-small-32'}>
        <Button
          action={async () => {
            try {
              await props.startSocialOAuth({
                variables: {
                  oAuthProvider: SocialOAuthProvider.FACEBOOK,
                  context: SocialOAuthContext.SIGNUP
                }
              });
            } catch (e) {
              /* need to have catch due tu Promise runtime error */
            }
          }}
          color={ButtonColorsEnum.facebook}
          expanded
          disabled={props.submitted}
          icon={{ side: 'left', value: IconsEnum.facebook }}
          size={'large'}
          type={'button'}
          variant={'solid'}>
          Sign up with Facebook
        </Button>
      </div>
      <div className={'grid-x align-justify'}>
        <div className={'cell shrink uppercase margin-bottom-small-32'}>
          <h6 className={'light-grey-text'}>or signup with email</h6>
        </div>
      </div>
      <form className={'grid-x grid-padding-x'} onSubmit={props.formInstance.handleSubmit(props.onSubmit)}>
        <div className={'cell small-12 margin-bottom-small-26'}>
          <Input
            disabled={props.submitted}
            formInstance={formInstance}
            name={'email'}
            type={InputTypes.email}
            size={'large'}
            inlinedLabel
            label={'Email'}
            rules={props.emailRules}
          />
        </div>
        <div className={'cell small-12'}>
          <Button
            type={'submit'}
            variant={'solid'}
            size={'large'}
            expanded
            disabled={props.submitted}
            color={ButtonColorsEnum.secondary}
            loading={props.submitted}>
            Continue With Email
          </Button>
        </div>
      </form>
    </div>
  );
};
